export interface SickTask {
  id: string;
  label: string;
  time: string;
  duration: string;
}

export interface SickTier {
  tier: string;
  color: string;
  accent: string;
  tasks: SickTask[];
}

export interface SickDayData {
  title: string;
  emoji: string;
  description: string;
  tiers: SickTier[];
}

export const SICK_DAY: SickDayData = {
  title: "Sick Day Minimum",
  emoji: "🤒",
  description: "When life hits hard. This is enough. You are enough.",
  tiers: [
    {
      tier: "🟢 If you have some energy",
      color: "#f0fdf4",
      accent: "#4caf66",
      tasks: [
        { id: "sk1", label: "Toddler fed — simple meals, snacks, milk. That's the job.",         time: "All day",    duration: "non-negotiable" },
        { id: "sk2", label: "One quick tidy — just the kitchen & one common area",               time: "Whenever",   duration: "~10 min" },
        { id: "sk3", label: "Diaper changes & basic hygiene for toddler",                        time: "As needed",  duration: "non-negotiable" },
        { id: "sk4", label: "Laundry if already started — just move it, don't fold",             time: "Whenever",   duration: "~5 min" },
        { id: "sk5", label: "Text someone you trust if you need help",                           time: "Anytime",    duration: "2 min" },
      ],
    },
    {
      tier: "🟡 Bare minimum — you or toddler is sick",
      color: "#fffbf0",
      accent: "#e8b43a",
      tasks: [
        { id: "sk6", label: "Toddler fed — snacks, simple food, whatever they'll eat",           time: "All day",   duration: "non-negotiable" },
        { id: "sk7", label: "Toddler has clean diaper & is safe",                                time: "All day",   duration: "non-negotiable" },
        { id: "sk8", label: "You drink water & rest when toddler sleeps",                        time: "Nap time",  duration: "priority" },
        { id: "sk9", label: "Screen time is okay today — grace, not guilt",                      time: "As needed", duration: "—" },
      ],
    },
    {
      tier: "🔴 Both of you are down — survival mode",
      color: "#fff0f0",
      accent: "#e87070",
      tasks: [
        { id: "sk10", label: "Call in support — husband, family, friend. Ask for help.",         time: "ASAP",     duration: "non-negotiable" },
        { id: "sk11", label: "Toddler safe & fed — everything else waits",                       time: "All day",  duration: "non-negotiable" },
        { id: "sk12", label: "Rest. The house will wait. Your health won't.",                    time: "All day",  duration: "priority" },
        { id: "sk13", label: "One thing: feed, rest, survive. Tomorrow is a new day.",           time: "Reminder", duration: "—" },
      ],
    },
  ],
};
